import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DraggableType } from '../../../types/dnd';
import Grid from '../../../Grid';
import { DndSortable, DndSortableElement } from '../../../Dnd/DndSortable';
import { isSpecialStuckGallection } from '../../helpers';
import { FOLDER_CARD_ASPECT_RATIO } from '../../../FolderCard/FolderCard';
import { useGlobalPrivs } from '../../_hocs/withGlobalPrivs';
import s from './GallectionGrid.scss';
const GallectionGrid = ({ gallections, cookieType, gallectionRenderer, moveGallectionToPosition })=>{
    const isMobile = useContext(MobileContext);
    const { canRearrangeGalleryFolders } = useGlobalPrivs();
    if (!gallections) {
        return null;
    }
    const elementAspectRatio = FOLDER_CARD_ASPECT_RATIO;
    const getFolderId = (index)=>{
        const item = gallections[index];
        return item.folderId;
    };
    const renderDndGallection = (_param)=>{
        var { draggedElementId } = _param, dndProps = _object_without_properties(_param, [
            "draggedElementId"
        ]);
        return (options)=>{
            const { style, index } = options;
            const item = gallections[index];
            const canMoveThisGallection = !isSpecialStuckGallection(item) && canRearrangeGalleryFolders && !!moveGallectionToPosition;
            if (!canMoveThisGallection) {
                return /*#__PURE__*/ React.createElement("div", {
                    style: style
                }, gallectionRenderer(options));
            }
            const isDragging = draggedElementId === item.folderId;
            return /*#__PURE__*/ React.createElement(DndSortableElement, _object_spread({
                dndType: DraggableType.MEDIA_MANAGER_GALLECTION,
                id: item.folderId,
                key: item.folderId,
                position: index,
                isSortable: canMoveThisGallection
            }, dndProps), (sortableOptions)=>/*#__PURE__*/ React.createElement("div", {
                    id: `${item.folderId}`,
                    ref: sortableOptions.ref,
                    key: item.folderId,
                    style: {
                        marginLeft: style.marginLeft
                    },
                    className: classnames(isDragging && s['dragging'])
                }, gallectionRenderer(options)));
        };
    };
    const onDndDragOver = (id, position)=>{
        moveGallectionToPosition({
            folderId: id,
            position,
            moveType: 'streamOnly'
        });
    };
    const onDndDrop = (id, position)=>{
        moveGallectionToPosition({
            folderId: id,
            position,
            moveType: 'papiOnly'
        });
    };
    return /*#__PURE__*/ React.createElement(DndSortable, {
        onDragOver: onDndDragOver,
        onDrop: onDndDrop
    }, (props)=>{
        const renderElement = renderDndGallection(props);
        return /*#__PURE__*/ React.createElement(Grid, {
            className: s['root'],
            breakByScreenWidth: false,
            breakpoints: [
                {
                    maxWidth: 400,
                    elementsPerRow: 1,
                    elementAspectRatio
                },
                {
                    maxWidth: 550,
                    elementsPerRow: 2,
                    elementAspectRatio
                },
                {
                    maxWidth: 800,
                    elementsPerRow: 3,
                    elementAspectRatio
                },
                {
                    maxWidth: 9999,
                    elementsPerRow: 4,
                    elementAspectRatio
                }
            ],
            cookieType: cookieType,
            elementCount: gallections.length,
            getElementId: getFolderId,
            renderElement: renderElement,
            spacing: isMobile ? 10 : 16,
            enableScrollOptim: false
        });
    });
};
GallectionGrid.displayName = 'GallectionGrid';
export default GallectionGrid;
